import { useEffect, useState } from "react";
import api from "../../services/api";
import HrModal from "../HR/HrModal";
import "../../assets/styles/PM/PMTicketsPg.css";

const priColor = (p) => ({ Critical:"#dc2626", High:"#ef4444", Medium:"#d97706", Low:"#2563eb" }[p] || "#94a3b8");
const stChip   = (s) => ({ resolved:"chip-ok", closed:"chip-dn", in_progress:"chip-wn" }[s] || "chip-ip");

export default function PMTicketsPg() {
  const [tickets, setTickets] = useState([]);
  const [loading,  setLoading] = useState(true);
  const [replyModal, setReplyModal] = useState(null);
  const [suc, setSuc] = useState("");
  const [filter, setFilter] = useState("all");
  const [respondModal, setRespondModal] = useState(null);
  const [respondText, setRespondText]   = useState("");
  const [respondSending, setRespondSending] = useState(false);

  const load = () => {
    setLoading(true);
    api.getPMTickets()
      .then(d => { setTickets(Array.isArray(d) ? d : []); setLoading(false); })
      .catch(() => setLoading(false));
  };
  useEffect(load, []);

  const handleRespondToHandler = async () => {
    if (!respondText.trim()) { alert("Please type your instructions."); return; }
    setRespondSending(true);
    try {
      await api.pmRespondToHandler(respondModal.ticket_id || respondModal.id, respondText.trim());
      setRespondModal(null); setRespondText("");
      setSuc("✅ Instructions sent to handler. They will reply to the employee.");
      setTimeout(() => setSuc(""), 5000);
      load();
    } catch (err) { alert("Error: " + err.message); }
    setRespondSending(false);
  };

  const needsForward = (t) => false;
  const forwardLabel = (t) => {
    const ot = String(t.original_target || "").toLowerCase();
    return ot === "hr" ? "HR" : "IT Admin";
  };

  const handleReply = async (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const action  = fd.get("action");
    const comment = fd.get("reply");
    try {
      await api.pmTicketAction(replyModal.ticket_id || replyModal.id, action, comment);
      setReplyModal(null);
      setSuc("✅ Response sent to employee!");
      setTimeout(() => setSuc(""), 4500);
      load();
    } catch (err) { alert("Error: " + err.message); }
  };

  const TABS = ["all","open","in_progress","resolved","closed"];
  const counts = TABS.reduce((a, f) => {
    a[f] = f === "all" ? tickets.length : tickets.filter(t => t.status === f).length;
    return a;
  }, {});

  const filtered = filter === "all" ? tickets : tickets.filter(t => t.status === filter);
  const toForward           = [];
  const pmDirect            = filtered.filter(t => !t.handler_escalated_to_pm);
  const handlerEscalated    = filtered.filter(t => t.handler_escalated_to_pm && !t.pm_response_to_handler);
  const handlerEscResponded = filtered.filter(t => t.handler_escalated_to_pm && !!t.pm_response_to_handler);
  const allRows = [...handlerEscalated, ...pmDirect, ...handlerEscResponded];

  return (
    <div>
      <div className="sec">Help Desk — Employee Tickets</div>

      {suc && (
        <div style={{ background:"#eff6ff", color:"#2563eb", border:"1px solid #bfdbfe",
          borderRadius:8, padding:"9px 14px", marginBottom:12, fontSize:13, fontWeight:600 }}>
          {suc}
        </div>
      )}

      {/* Status tabs */}
      <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginBottom:16 }}>
        {TABS.map(f => (
          <button key={f} onClick={() => setFilter(f)}
            className={`tab-btn${filter===f?" active":""}`}>
            {f === "all" ? "All" : f.replace("_"," ")}
            <span style={{ marginLeft:6, background:filter===f?"rgba(255,255,255,.3)":"#e2e8f0",
              color:filter===f?"#fff":"#64748b", borderRadius:10, padding:"0 6px", fontSize:10, fontWeight:700 }}>
              {counts[f]}
            </span>
          </button>
        ))}
        {handlerEscalated.length > 0 && (
          <span style={{ background:"#fef2f2", color:"#dc2626", border:"1px solid #fecaca",
            borderRadius:8, padding:"4px 10px", fontSize:11, fontWeight:700, alignSelf:"center" }}>
            🔺 {handlerEscalated.length} Escalated to You
          </span>
        )}
      </div>

      <div className="cd">
        <div className="cd-h">
          <div className="cd-t">Tickets Assigned to You</div>
          <div className="cd-s">{allRows.length} shown</div>
        </div>
        <div className="cd-b" style={{ overflowX:"auto", padding:0 }}>
          {loading ? (
            <div style={{ textAlign:"center", padding:40, color:"#94a3b8" }}>Loading…</div>
          ) : allRows.length === 0 ? (
            <div style={{ textAlign:"center", padding:40, color:"#94a3b8" }}>No tickets</div>
          ) : (
            <table className="tbl">
              <thead>
                <tr>
                  <th>Employee</th><th>Dept</th><th>Subject</th>
                  <th>Priority</th><th>Status</th><th>For</th><th>Date</th><th>Action</th>
                </tr>
              </thead>
              <tbody>
                {allRows.map(t => {
                  const fwd = false;
                  const alreadyFwded = false;
                  const handlerEsc = !!t.handler_escalated_to_pm;
                  const pmResponded = !!t.pm_response_to_handler;
                  return (
                    <tr key={t.ticket_id||t.id}
                      style={{ background: handlerEsc && !pmResponded ? "#fef2f2" : "transparent" }}>
                      <td style={{ fontWeight:500 }}>{t.name||"—"}</td>
                      <td style={{ fontSize:11, color:"#64748b" }}>{t.department||"—"}</td>
                      <td style={{ maxWidth:180, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", fontSize:12 }}>
                        {t.subject}
                      </td>
                      <td>
                        <span style={{ background:priColor(t.priority)+"18", color:priColor(t.priority),
                          border:`1px solid ${priColor(t.priority)}33`,
                          padding:"2px 8px", borderRadius:20, fontSize:11, fontWeight:700 }}>
                          {t.priority||"Medium"}
                        </span>
                      </td>
                      <td>
                        <span className={`chip ${stChip(t.status)}`}>
                          {String(t.status||"open").replace("_"," ")}
                        </span>
                      </td>
                      <td>
                        {handlerEsc && !pmResponded ? (
                          <span style={{ background:"#fef2f2", color:"#dc2626", borderRadius:6, padding:"2px 8px", fontSize:10, fontWeight:700 }}>
                            🔺 Escalated
                          </span>
                        ) : handlerEsc && pmResponded ? (
                          <span style={{ background:"#dcfce7", color:"#16a34a", borderRadius:6, padding:"2px 8px", fontSize:10, fontWeight:700 }}>
                            ✅ Responded
                          </span>
                        ) : (
                          <span style={{ color:"#94a3b8", fontSize:11 }}>PM Direct</span>
                        )}
                      </td>
                      <td style={{ fontSize:11, color:"#94a3b8", whiteSpace:"nowrap" }}>
                        {t.created_at ? new Date(t.created_at).toLocaleDateString("en-IN",{day:"2-digit",month:"short"}) : "—"}
                      </td>
                      <td>
                        {handlerEsc && !pmResponded ? (
                          <button className="btn btn-s"
                            onClick={() => { setRespondModal(t); setRespondText(""); }}
                            style={{ background:"#dc2626", borderColor:"#dc2626", color:"#fff" }}>
                            🔺 Respond
                          </button>
                        ) : (
                          <button className="btn btn-s btn-o" onClick={() => setReplyModal(t)}>
                            💬 Reply
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* ── Reply Modal (PM-direct tickets) ── */}
      {replyModal && (
        <HrModal open={!!replyModal} title={`Ticket — ${replyModal.subject}`} onClose={() => setReplyModal(null)}>
          <div style={{ background:"#f8fafc", borderRadius:8, padding:"10px 14px", marginBottom:14 }}>
            <div style={{ fontSize:12, color:"#64748b" }}>
              Employee: <b>{replyModal.name}</b> &nbsp;·&nbsp; {replyModal.category}
            </div>
            <div style={{ fontSize:13, color:"#374151", marginTop:6, lineHeight:1.6,
              background:"#fff", borderRadius:8, padding:"8px 12px", border:"1px solid #e2e8f0" }}>
              {replyModal.description || "No description"}
            </div>
          </div>
          <form onSubmit={handleReply}>
            {replyModal.reviewer_note && (
              <div style={{ background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:8,
                padding:"10px 14px", marginBottom:12 }}>
                <div style={{ fontSize:11, fontWeight:700, color:"#16a34a", marginBottom:4 }}>Previous Reply</div>
                <div style={{ fontSize:13, color:"#15803d" }}>{replyModal.reviewer_note}</div>
              </div>
            )}
            <div className="fg">
              <label className="fl">Reply to Employee *</label>
              <textarea name="reply" className="fi" rows={4}
                placeholder="Type your response to the employee…"
                required />
            </div>
            <div className="fg">
              <label className="fl">Action</label>
              <select name="action" className="fi" defaultValue="approved">
                <option value="approved">Resolve</option>
                <option value="rejected">Reject / Close</option>
                <option value="resend">Request More Info</option>
              </select>
            </div>
            <div className="fa">
              <button type="button" className="btn btn-o" onClick={() => setReplyModal(null)}>Cancel</button>
              <button type="submit" className="btn btn-p">💬 Send Reply to Employee</button>
            </div>
          </form>
        </HrModal>
      )}

      {/* ── Respond to Handler Modal (IT Admin / HR escalated to PM) ── */}
      {respondModal && (
        <HrModal open title={`🔺 Respond to Handler — ${respondModal.subject}`} onClose={() => { setRespondModal(null); setRespondText(""); }}>
          <div style={{ background:"#fef2f2", border:"1px solid #fecaca", borderRadius:8, padding:"10px 14px", marginBottom:14 }}>
            <div style={{ fontSize:11, fontWeight:700, color:"#dc2626", marginBottom:4 }}>ESCALATED TICKET</div>
            <div style={{ fontWeight:600, fontSize:13, color:"#1e293b" }}>{respondModal.subject}</div>
            <div style={{ fontSize:12, color:"#64748b", marginTop:2 }}>
              Employee: <b>{respondModal.name||"—"}</b> &nbsp;·&nbsp;
              Handler: <b>{respondModal.handler_escalated_by||"IT Admin / HR"}</b>
            </div>
          </div>

          <div style={{ background:"#f8fafc", borderRadius:8, padding:"10px 12px", marginBottom:12 }}>
            <div style={{ fontSize:11, fontWeight:600, color:"#64748b", marginBottom:4 }}>EMPLOYEE'S ISSUE</div>
            <div style={{ fontSize:13, color:"#374151", lineHeight:1.5 }}>{respondModal.description||"No description provided"}</div>
          </div>

          {respondModal.handler_escalation_note && (
            <div style={{ background:"#fff7ed", border:"1px solid #fed7aa", borderRadius:8, padding:"10px 14px", marginBottom:14 }}>
              <div style={{ fontSize:11, fontWeight:700, color:"#c2410c", marginBottom:4 }}>
                {respondModal.handler_escalated_by||"Handler"}'s Note to You (internal)
              </div>
              <div style={{ fontSize:13, color:"#7c2d12", lineHeight:1.5 }}>{respondModal.handler_escalation_note}</div>
            </div>
          )}

          <div style={{ background:"#f0f9ff", border:"1px solid #bae6fd", borderRadius:8, padding:"10px 14px", marginBottom:14, fontSize:12, color:"#0369a1" }}>
            <b>Instructions:</b> Type your response below. This will be sent to{" "}
            {respondModal.handler_escalated_by||"IT Admin / HR"} privately. They will then reply directly to the employee.
            The employee will <b>NOT</b> see this message.
          </div>

          <div className="fg">
            <label className="fl">Your Instructions to {respondModal.handler_escalated_by||"IT Admin / HR"} *</label>
            <textarea className="fi" rows={5}
              placeholder={`Write clear instructions for ${respondModal.handler_escalated_by||"the handler"} on how to resolve this ticket.`}
              value={respondText} onChange={e => setRespondText(e.target.value)} />
          </div>

          <div className="fa" style={{ gap:8 }}>
            <button type="button" className="btn btn-o" onClick={() => { setRespondModal(null); setRespondText(""); }}>Cancel</button>
            <button onClick={handleRespondToHandler} disabled={respondSending || !respondText.trim()}
              style={{ padding:"9px 20px", background:"#1d4ed8", color:"#fff", border:"none",
                borderRadius:8, fontWeight:700, fontSize:13, cursor:"pointer",
                opacity:(!respondText.trim()||respondSending)?0.6:1 }}>
              {respondSending ? "Sending…" : "📤 Send Instructions to Handler"}
            </button>
          </div>
        </HrModal>
      )}
    </div>
  );
}
